export default {
  selected: null,
};
